<template>
  <div
    v-if="showBanner"
    class="pass-fees-banner"
  >
    <img
      :src="`${publicPath}img/${$t('pass-fees.image')}`"
      width="133"
      height="133"
    >
    <div>
      <h3>{{ $t("pass-fees.header") }}</h3>
      <h4
        v-if="showDiscountBelow"
        v-html="$t('pass-fees.discount-below-subheader')"
      />
      <h4
        v-else-if="showDiscount"
        v-html="$t('pass-fees.discount-subheader')"
      />
      <h4
        v-else
        v-html="$t('pass-fees.subheader')"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showDiscount: Boolean,
    showDiscountBelow: Boolean,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {
    showBanner() {
      return this.$store.state.systemId === 'rtc';
    },
  },
};
</script>
